import React from 'react';
import Cookies from 'js-cookie';
import * as serverRenderingUtils from 'helpers/serverRenderingUtils';

const developmentHostnames = ['localhost', 'development.anchor.fm'];

type LocaleProviderValue = {
  changeLocale: (newLocale: string) => void;
  enableI18N: boolean;
  locale: string;
};

export const LocaleContext = React.createContext<LocaleProviderValue>({
  changeLocale: () => {},
  enableI18N: false,
  locale: 'en',
});

export function LocaleProvider({
  locale = 'en',
  children,
}: {
  locale?: string;
  children: React.ReactNode;
}): React.ReactElement {
  // enableI18N Flag for 2022 i18n Launch (local and dev only)
  const enableI18N =
    !serverRenderingUtils.windowUndefined() &&
    developmentHostnames.includes(window.location.hostname);
  const [currentLocale, setCurrentLocale] = React.useState<string>(locale);

  const persistLocale = (requestedLocale: string) => {
    Cookies.set('i18n', requestedLocale);
  };

  const changeLocale = (requestedLocale: string) => {
    // Safety check to not run the changeLanguage function when unneccessary
    if (requestedLocale === currentLocale) {
      /* eslint-disable-next-line no-console */
      console.log('The preferred language is already set: ', currentLocale);
      return;
    }

    setCurrentLocale(requestedLocale);
    if (enableI18N) persistLocale(requestedLocale);
  };

  return (
    <LocaleContext.Provider
      value={{
        locale: currentLocale,
        enableI18N,
        changeLocale,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
}
